// token-fflate.js
import { deflateSync, inflateSync } from 'fflate';

/** Recursively sort object keys for stable stringification */
function sortKeys(obj) {
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    const out = {};
    Object.keys(obj)
      .sort()
      .forEach((k) => {
        out[k] = sortKeys(obj[k]);
      });
    return out;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => sortKeys(item));
  }
  return obj;
}

/** Base64URL helpers (URL-safe, no padding) */
function toBase64Url(bytes) {
  let bin = '';
  bytes.forEach((b) => {
    bin += String.fromCharCode(b);
  });
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function fromBase64Url(s) {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4);
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  bin.split('').forEach((b, i) => {
    bytes[i] = b.charCodeAt(0);
  });
  return bytes;
}

/**
 * Encode: JSON → UTF-8 → deflate → base64url
 */
export function encodeToken(value) {
  const sorted = sortKeys(value);
  const json = JSON.stringify(sorted);
  const utf8 = new TextEncoder().encode(json);
  const zipped = deflateSync(utf8, { level: 9 }); // max compression
  return toBase64Url(zipped);
}

/**
 * Decode: base64url → inflate → UTF-8 → JSON
 */
export function decodeToken(token) {
  const zipped = fromBase64Url(token);
  const utf8 = inflateSync(zipped);
  const json = new TextDecoder().decode(utf8);
  return JSON.parse(json);
}
